import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ImageHead from '../../../components/ImageHead';
// import ScheduleTable from '../../../components/ScheduleTable';

const Schedule = ({ content }) => {
    const { scheduleHead, scheduleList } = content;

    return (
        <div className={styles.schedule}>
            <Chip id="260339" type="struct" title="论坛日程头" groupName="论坛日程" content={scheduleHead}>
                <ImageHead />
            </Chip>
            <Chip id="260356" type="struct" title="论坛日程列表" groupName="论坛日程">
                <div className={styles.scheduleScroll}>
                    {scheduleList.map((item, index) => {
                        return <img key={index} className={styles.schedulePic} src={item.url} />;
                    })}
                </div>
            </Chip>
        </div>
    );
};

Schedule.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Schedule);
